import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

const themeDev = require('../../shared/styles/themes/theme-dev.scss');
const themeStaging = require('../../shared/styles/themes/theme-staging.scss');
const themeProd = require('../../shared/styles/themes/theme-production.scss');
const themeLocal = require('../../shared/styles/themes/theme-local.scss');

@Injectable()
export class ThemesService {

  styleTag: any;

  constructor() {
    this.createStyle();
    this.setTheme(environment.theme);
  }

  public setTheme(name: string) {
    switch (name) {
      case 'theme-development':
        this.injectStylesheet(themeDev);
        break;
      case 'theme-staging':
        this.injectStylesheet(themeStaging);
        break;
      case 'theme-production':
        this.injectStylesheet(themeProd);
        break;
      default:
        this.injectStylesheet(themeLocal);
        break;
    }
  }

  private createStyle() {
    const head = document.head || document.getElementsByTagName('head')[0];
    this.styleTag = document.createElement('style');
    this.styleTag.type = 'text/css';
    this.styleTag.id = 'appthemes';
    head.appendChild(this.styleTag);
  }

  private injectStylesheet(css: string) {
    this.styleTag.innerHTML = css;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/themes/themes.service.ts